import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import $api from './api'
import ElementUI from 'element-ui/lib/element-ui.common.js';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.prototype.$api = $api
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/swiper.less'
// If you use Swiper 6.0.0 or higher
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper)

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
